import type { Rect } from "@gooner/shared";

/**
 * A tiny diagram of a set of normalized rects, used to preview a layout preset
 * (or a monitor's region layout). Renders inside a fixed-aspect box so every
 * thumbnail lines up in the grid. `aspect` defaults to 16:9; pass a monitor's
 * own aspect to preview portrait/other screens faithfully.
 */
export function PresetThumb({
  rects,
  aspect,
  className,
}: {
  rects: Rect[];
  aspect?: { w: number; h: number };
  className?: string;
}) {
  return (
    <div
      className={`relative w-full overflow-hidden rounded-md bg-[var(--color-ink)] ${className ?? ""}`}
      style={{ aspectRatio: `${aspect?.w ?? 16} / ${aspect?.h ?? 9}` }}
    >
      {rects.map((r, i) => (
        <div
          key={i}
          className="absolute rounded-[2px] border border-[var(--color-accent)]/50 bg-[var(--color-accent)]/15"
          style={{
            left: `${r.x * 100}%`,
            top: `${r.y * 100}%`,
            width: `${r.w * 100}%`,
            height: `${r.h * 100}%`,
            // hairline inset so adjacent cells read as distinct tiles
            outline: "1px solid rgba(10,10,11,0.6)",
          }}
        />
      ))}
    </div>
  );
}
